var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamBalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66658 9.33203C2.12682 9.33203 2.49992 8.95894 2.49992 8.4987C2.49992 8.03846 2.12682 7.66536 1.66658 7.66536C1.20635 7.66536 0.833252 8.03846 0.833252 8.4987C0.833252 8.95894 1.20635 9.33203 1.66658 9.33203Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66658 3.4987C2.12682 3.4987 2.49992 3.1256 2.49992 2.66536C2.49992 2.20513 2.12682 1.83203 1.66658 1.83203C1.20635 1.83203 0.833252 2.20513 0.833252 2.66536C0.833252 3.1256 1.20635 3.4987 1.66658 3.4987Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66658 15.1654C2.12682 15.1654 2.49992 14.7923 2.49992 14.332C2.49992 13.8718 2.12682 13.4987 1.66658 13.4987C1.20635 13.4987 0.833252 13.8718 0.833252 14.332C0.833252 14.7923 1.20635 15.1654 1.66658 15.1654Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamBalls);
export default __webpack_public_path__ + "static/media/ham-balls.1b83a32333a3d2101d281889a45fe524.svg";
export { ForwardRef as ReactComponent };